import axios from 'axios';
import { apiLoginUrl } from '../config';

/**
 * POST Login.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {string} [props.username]
 * @param {string} [props.password]
 * @returns {Promise}
 */
const login = (props = {}) => {
  const { password, requestConfig, username } = props;

  const method = 'post';
  const url = apiLoginUrl;

  const formData = new FormData();
  formData.append('j_username', username);
  formData.append('j_password', password);

  return axios({
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    method,
    url,
    ...requestConfig
  });
};

export default login;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/login.js